import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_90: FaireProductEntity = {
  token: "catalog_prod_prod-90",
  type: "product",
  name: "Decorative Item A",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 89.9,
  msrpDollars: 224.75,
  sku: "CA0090",
  caseSize: 1,
  material: "Wood",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 250,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_book-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
